// extracted by mini-css-extract-plugin
export default {"digitalImpact":"DigitalImpact_digitalImpact__2kDNp","counterCard":"DigitalImpact_counterCard__Bww3g"};